<template>
  <div :class="classGrid" :key="pergunta && pergunta.cd_pergunta">
    <label
      v-for="opcao in opcoes"
      :key="opcao.cd_resposta"
      class="checkbox-card"
      :for="getInputId(opcao.cd_resposta)"
      :class="{ active: estaSelecionada(opcao.cd_resposta), disabled }"
    >
      <b-form-checkbox
        class="checkbox-input"
        v-model="valorSelecionado"
        :disabled="disabled"
        :value="opcao.cd_resposta"
        :id="getInputId(opcao.cd_resposta)"
      />

      <div class="content">
        <div class="title">{{ opcao.ds_resposta }}</div>
        <div v-if="opcao.ds_observacao" class="description">
          {{ opcao.ds_observacao }}
        </div>
      </div>
    </label>
  </div>
</template>

<script lang="js">
export default {
  name: "RespostaCheckbox",

  props: {
    pergunta: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [String, Number, Array],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    opcoes() {
      return Array.isArray(this.pergunta?.respostas)
        ? this.pergunta.respostas
        : [];
    },

    classGrid() {
      return this.opcoes.length > 3
        ? "resposta-checkbox-grid"
        : "resposta-checkbox";
    },

    valorSelecionado: {
      get() {
        if (Array.isArray(this.modelValue)) {
          return this.modelValue;
        }

        if (
          this.modelValue === null ||
          this.modelValue === undefined ||
          this.modelValue === ""
        ) {
          return [];
        }

        return [this.modelValue];
      },
      set(value) {
        this.$emit("update:modelValue", Array.isArray(value) ? value : []);
      }
    }
  },

  methods: {
    getInputId(cdResposta) {
      const perguntaId = this.pergunta?.cd_pergunta || "pergunta";
      return `resposta-checkbox-${perguntaId}-${cdResposta}`;
    },

    estaSelecionada(cdResposta) {
      return this.valorSelecionado.some(
        valor => String(valor) === String(cdResposta)
      );
    }
  }
};
</script>

<style lang="scss">
.resposta-checkbox {
  gap: 5px;
  display: flex;
  flex-direction: column;
}

.resposta-checkbox-grid {
  display: grid;
  gap: 5px;
}

.checkbox-card {
  gap: 5px;
  display: flex;
  padding: 16px;
  cursor: pointer;
  border-radius: 10px;
  align-items: center;
  transition: all 0.2s ease;
  border: 1px solid rgb(226 232 240 / 1);
}

.checkbox-card:hover {
  border-color: rgb(0 146 63 / 0.5) !important;
  background-color: rgb(248 249 250 / 1) !important;
}

.checkbox-card.active {
  border-color: #149a4e;
  background: #f2f9f5;
}

.checkbox-card.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.checkbox-input {
  flex-shrink: 0;
}

.content {
  display: flex;
  flex-direction: column;
}

.title {
  font-weight: 600;
  color: #0d2345;
}

.description {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 4px;
  line-height: 1.4;
}

.checkbox-card input[type="checkbox"] {
  font-size: large !important;
  border-radius: 3px;
}

.checkbox-card input[type="checkbox"]:checked {
  background: #00923f;
  border-color: #00923f;
}
</style>
